<div class="booking-container" *ngIf="!loader">
  <div class="heading_sert">
    <sm-title-bar
      pageTitle="Loyalty rewards"
      [backWithParams]="true"
      [headerCustomTemplate]="addButton"
    >
      <ng-template #addButton>
        <!-- <button mat-flat-button color="accent" >
          <mat-icon class="material-icons-round" [inline]="true">add_circle</mat-icon>
          Create
        </button> -->
        <!-- *ngIf="couponData.length > 0 && !isLoading" -->
        <div class="create_btnyh">
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
        </div>
        <mat-menu #menu="matMenu" class="wallet-menu">
          <button mat-menu-item (click)="openPointConversion()">
            <mat-icon class="material-icons-outlined">settings</mat-icon>
            <span>Point conversion</span>
          </button>
        </mat-menu>
      </ng-template>
    </sm-title-bar>
  </div>

  <div class="chip_services_list">
    <mat-chip-listbox class="example-chip">
      <mat-chip
        [ngClass]="{ selectloyalty: selectedValue == 3 }"
        (click)="selectchip(3)"
        >Referral loyalty</mat-chip
        >
        <mat-chip
          [ngClass]="{ selectloyalty: selectedValue == 2 }"
          (click)="selectchip(2)"
          >Payment loyalty</mat-chip
        >
      <mat-chip
        [ngClass]="{ selectloyalty: selectedValue == 4 }"
        (click)="selectchip(4)"
        >Membership loyalty</mat-chip
      >
      <mat-chip
        [ngClass]="{ selectloyalty: selectedValue == 1 }"
        (click)="selectchip(1)"
        >Booking loyalty</mat-chip
      >
    </mat-chip-listbox>
  </div>

  <div class="row">
    <div class="col-sm-12">
      <div class="lsk_cardf" *ngIf="selectedValue == 1">
        <div class="serv_heading">
          <div class="adm_set">
            <mat-slide-toggle
              (change)="onToggleChangeForBooking($event)"
              [checked]="toShowCheckForBooking === 1"
            ></mat-slide-toggle>
          </div>
          <h3>Booking loyalty reward status</h3>
          <p class="booking_parax">
            {{
              toShowCheckForBooking == 1
                ? "Booking loyalty is enabled"
                : "Booking loyalty is disabled"
            }}
          </p>
        </div>
        <div class="configuration_description">
          <p>
            Let's reward your customer for their loyalty. Booking rewards allows
            customers to earn points when they book appointments through app or
            web, which they can later redeem for rewards like discounts, free
            services, or products.
          </p>
        </div>

        <div *ngIf="toShowCheckForBooking == 1">
          <div class="mainpadding" *ngIf="shop_status != '2'">
            <div class="item_list add_padding mainlist">
              <div class="item_list_data">
                <span>Shop booking</span>
                <mat-slide-toggle
                  [(ngModel)]="isShopBookingEnabled"
                ></mat-slide-toggle>
              </div>
              <div
                class="loyalty_payment_box"
                *ngIf="isShopBookingEnabled"
                style="padding: 10px"
              >
                <div class="loyalty_points_wrap">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                    ><mat-label>Point per booking</mat-label>
                    <input
                      matInput
                      type="number"
                      smDecimalOnly
                      [(ngModel)]="bookingShopPoints"
                      placeholder="Enter points"
                    />
                  </mat-form-field>
                </div>
                <div class="loyalty_points_wrap">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                    ><mat-label>Valid for (days)</mat-label>
                    <input
                      matInput
                      type="number"
                      smNumericOnly
                      [(ngModel)]="bookingShopValidity"
                      placeholder="Enter validity days"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="mainpadding" *ngIf="home_status != '2'">
            <div class="item_list add_padding mainlist">
              <div class="item_list_data">
                <span>Home booking</span>
                <mat-slide-toggle
                  [(ngModel)]="isHomeBookingEnabled"
                ></mat-slide-toggle>
              </div>
              <div class="loyalty_payment_box" *ngIf="isHomeBookingEnabled">
                <div class="loyalty_points_wrap">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                    ><mat-label>Point per booking</mat-label>
                    <input
                      matInput
                      type="number"
                      smDecimalOnly
                      [(ngModel)]="bookingHomePoints"
                      placeholder="Enter points"
                    />
                  </mat-form-field>
                </div>
                <div class="loyalty_points_wrap">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                    ><mat-label>Valid for (days)</mat-label>
                    <input
                      matInput
                      type="number"
                      smNumericOnly
                      [(ngModel)]="bookingHomeValidity"
                      placeholder="Enter validity days"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="mainpadding" *ngIf="virtual_status != '2'">
            <div class="item_list add_padding mainlist">
              <div class="item_list_data">
                <span>Virtual booking</span>
                <mat-slide-toggle
                  [(ngModel)]="isVirtualBookingEnabled"
                ></mat-slide-toggle>
              </div>
              <div class="loyalty_payment_box" *ngIf="isVirtualBookingEnabled">
                <div class="loyalty_points_wrap">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                    ><mat-label>Point per booking</mat-label>
                    <input
                      matInput
                      type="number"
                      smDecimalOnly
                      [(ngModel)]="bookingVirtualPoints"
                      placeholder="Enter points"
                    />
                  </mat-form-field>
                </div>
                <div class="loyalty_points_wrap">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                    ><mat-label>Valid for (days)</mat-label>
                    <input
                      matInput
                      type="number"
                      smNumericOnly
                      [(ngModel)]="bookingVirtualValidity"
                      placeholder="Enter validity days"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="cabh_sect">
            <button
              (click)="saveBookingLoyaltyConfiguration()"
              [disabled]="isBookingSaveDisabled()"
              mat-flat-button
              color="accent"
              class="submit-btn"
            >
              Save
            </button>
          </div>
        </div>
      </div>

      <div class="lsk_cardf" *ngIf="selectedValue == 2">
        <div class="serv_heading">
          <div class="adm_set">
            <mat-slide-toggle
              (change)="onToggleChangeForPayment($event)"
              [checked]="toShowCheckForPayment === 1"
            ></mat-slide-toggle>
          </div>
          <h3>Payment loyalty reward status</h3>
          <p class="booking_parax">
            {{
              toShowCheckForPayment === 1
                ? "Payment loyalty is enabled"
                : "Payment loyalty is disabled"
            }}
          </p>
        </div>
        <div class="configuration_description">
          <p>
            Reward points for invoice/bill payment will allow your customers to
            earn loyalty points when they pay invoices through app or integrated
            web system. These points can later be redeemed for discounts, free
            services, or other perks.
          </p>
        </div>

        <div *ngIf="toShowCheckForPayment === 1">
          <div class="item_list add_padding">
            <div class="item_list_data">
              <span>Appointment payment</span
              ><mat-slide-toggle
                [(ngModel)]="isAppointmentPaymentEnabled"
              ></mat-slide-toggle>
            </div>
            <div
              class="loyalty_payment_box"
              *ngIf="isAppointmentPaymentEnabled"
            >
              <mat-radio-group
                class="payment_radio_group"
                [(ngModel)]="appointmentPaymentType"
              >
                <div class="radio_row mainpayment">
                  <mat-radio-button value="each_payment"
                    >On each payment</mat-radio-button
                  ><mat-radio-button value="payment_amount"
                    >On payment amount</mat-radio-button
                  >
                </div>
              </mat-radio-group>
              <div *ngIf="appointmentPaymentType === 'each_payment'">
                <mat-form-field appearance="outline"
                  ><mat-label>Point per payment</mat-label
                  ><input
                    matInput
                    type="number"
                    smDecimalOnly
                    [(ngModel)]="aptFixedPoints"
                /></mat-form-field>
              </div>
              <div
                class="each_pay"
                *ngIf="appointmentPaymentType === 'payment_amount'"
              >
                <div class="radio_row matrow">
                  <div class="amount_input">
                    <span class="text_label"
                      >For each {{ currencyInfo.currencySymbol }}</span
                    >
                    <mat-form-field appearance="outline" class="mobile_form">
                      <input
                        matInput
                        type="number"
                        smDecimalOnly
                        [(ngModel)]="aptAmountLimit"
                      />
                    </mat-form-field>
                    <span class="text_label opentrat">payment,</span>
                  </div>
                  <div class="amount_input paymenx">
                    <span class="text_label">Reward</span
                    ><mat-form-field appearance="outline" class="mobile_form"
                      ><input
                        matInput
                        type="number"
                        smDecimalOnly
                        [(ngModel)]="aptRewardPoints"
                    /></mat-form-field>
                    <div class="xvp">
                      <span class="text_label opentrat">point(s)</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="loyalty_points_wrap"
                *ngIf="isAppointmentPaymentEnabled"
              >
                <mat-form-field appearance="outline" class="mobile_form col-12"
                  ><mat-label>Valid for (days)</mat-label>
                  <input
                    [(ngModel)]="paymentAppointmentValidity"
                    matInput
                    type="number"
                    smNumericOnly
                    placeholder="Enter validity days"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="item_list add_padding">
            <div class="item_list_data">
              <span>Membership payment</span
              ><mat-slide-toggle
                [(ngModel)]="isMembershipPaymentEnabled"
              ></mat-slide-toggle>
            </div>
            <div class="loyalty_payment_box" *ngIf="isMembershipPaymentEnabled">
              <mat-radio-group
                class="payment_radio_group"
                [(ngModel)]="membershipPaymentType"
              >
                <div class="radio_row mainpayment">
                  <mat-radio-button value="each_payment"
                    >On each payment</mat-radio-button
                  ><mat-radio-button value="payment_amount"
                    >On payment amount</mat-radio-button
                  >
                </div>
              </mat-radio-group>
              <div *ngIf="membershipPaymentType === 'each_payment'">
                <mat-form-field appearance="outline"
                  ><mat-label>Point per payment</mat-label
                  ><input
                    matInput
                    type="number"
                    smDecimalOnly
                    [(ngModel)]="memFixedPoints"
                /></mat-form-field>
              </div>
              <div
                class="each_pay"
                *ngIf="membershipPaymentType === 'payment_amount'"
              >
                <div class="radio_row matrow">
                  <div class="amount_input">
                    <span class="text_label"
                      >For each {{ currencyInfo.currencySymbol }}</span
                    >
                    <mat-form-field appearance="outline" class="mobile_form">
                      <input
                        matInput
                        type="number"
                        smDecimalOnly
                        [(ngModel)]="memAmountLimit"
                      />
                    </mat-form-field>
                    <span class="text_label opentrat">payment,</span>
                  </div>
                  <div class="amount_input paymenx">
                    <span class="text_label">Reward</span
                    ><mat-form-field appearance="outline" class="mobile_form"
                      ><input
                        matInput
                        type="number"
                        smDecimalOnly
                        [(ngModel)]="memRewardPoints"
                    /></mat-form-field>
                    <div class="xvp">
                      <span class="text_label opentrat">point(s)</span>
                    </div>
                  </div>
                </div>
                <div
                  class="loyalty_points_wrap"
                  *ngIf="isMembershipPaymentEnabled"
                >
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                    ><mat-label>Valid for (days)</mat-label>
                    <input
                      [(ngModel)]="paymentMembrshipValidity"
                      matInput
                      type="number"
                      smNumericOnly
                      placeholder="Enter validity days"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>

          <div class="item_list add_padding">
            <div class="item_list_data">
              <span>Other payment</span
              ><mat-slide-toggle
                [(ngModel)]="isOtherPaymentEnabled"
              ></mat-slide-toggle>
            </div>
            <div class="loyalty_payment_box" *ngIf="isOtherPaymentEnabled">
              <mat-radio-group
                class="payment_radio_group"
                [(ngModel)]="otherPaymentType"
              >
                <div class="radio_row mainpayment">
                  <mat-radio-button value="each_payment"
                    >On each payment</mat-radio-button
                  ><mat-radio-button value="payment_amount"
                    >On payment amount</mat-radio-button
                  >
                </div>
              </mat-radio-group>
              <div *ngIf="otherPaymentType === 'each_payment'">
                <mat-form-field appearance="outline"
                  ><mat-label>Point per payment</mat-label
                  ><input
                    matInput
                    type="number"
                    smDecimalOnly
                    [(ngModel)]="othFixedPoints"
                /></mat-form-field>
              </div>
              <div
                class="each_pay"
                *ngIf="otherPaymentType === 'payment_amount'"
              >
                <div class="radio_row matrow">
                  <div class="amount_input">
                    <span class="text_label"
                      >For each {{ currencyInfo.currencySymbol }}</span
                    ><mat-form-field appearance="outline" class="mobile_form"
                      ><input
                        matInput
                        type="number"
                        smDecimalOnly
                        [(ngModel)]="othAmountLimit"
                    /></mat-form-field>
                    <span class="text_label opentrat">payment,</span>
                  </div>
                  <div class="amount_input paymenx">
                    <span class="text_label">Reward</span
                    ><mat-form-field appearance="outline" class="mobile_form"
                      ><input
                        matInput
                        type="number"
                        smDecimalOnly
                        [(ngModel)]="othRewardPoints"
                    /></mat-form-field>
                    <div class="xvp">
                      <span class="text_label opentrat">point(s)</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="loyalty_points_wrap" *ngIf="isOtherPaymentEnabled">
                <mat-form-field appearance="outline" class="mobile_form col-12"
                  ><mat-label>Valid for (days)</mat-label>
                  <input
                    [(ngModel)]="paymentOtherValidity"
                    matInput
                    type="number"
                    smNumericOnly
                    placeholder="Enter validity days"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="cabh_sect">
            <button
              (click)="savePaymentLoyaltyConfiguration()"
              [disabled]="isPaymentSaveDisabled()"
              mat-flat-button
              color="accent"
              class="submit-btn"
            >
              Save
            </button>
          </div>
        </div>
      </div>

      <div class="lsk_cardf" *ngIf="selectedValue == 3">
        <div class="serv_heading">
          <div class="adm_set">
            <mat-slide-toggle
              (change)="onToggleChangeForReferral($event)"
              [checked]="toShowCheckForReferral === 1"
            ></mat-slide-toggle>
          </div>
          <h3>Referral loyalty reward status</h3>
          <p class="booking_parax">
            {{
              toShowCheckForReferral === 1
                ? "Referral loyalty is enabled"
                : "Referral loyalty is disabled"
            }}
          </p>
        </div>
        <div class="configuration_description">
          <p>
            A "Refer-a-friend" program let your customer earn reward points for
            successfully inviting new customers to the business. It's a win-win.
            Your referrer customer gets a reward for helping the business grow.
            You get a new customer.
          </p>
        </div>

        <div *ngIf="toShowCheckForReferral === 1">
          <div class="item_list add_padding">
            <div class="item_list_data">
              <span>On refer a friend</span
              ><mat-slide-toggle
                [(ngModel)]="isReferFriendEnabled"
              ></mat-slide-toggle>
            </div>
            <div class="loyalty_payment_box" *ngIf="isReferFriendEnabled">
              <div class="loyalty_points_wrap">
                <mat-form-field appearance="outline" class="mobile_form col-12"
                  ><mat-label>Points per refer</mat-label
                  ><input
                    matInput
                    type="number"
                    smDecimalOnly
                    [(ngModel)]="referFriendPoints"
                /></mat-form-field>
              </div>
              <div class="loyalty_points_wrap">
                <mat-form-field appearance="outline" class="mobile_form col-12"
                  ><mat-label>Valid for (days)</mat-label>
                  <input
                    [(ngModel)]="referralValidity"
                    matInput
                    type="number"
                    smNumericOnly
                    placeholder="Enter validity days"
                  />
                </mat-form-field>
              </div>
              <div class="loyalty_payment_box" style="padding: 10px 15px 0px">
                <div
                  class="add_crt"
                  style="
                    display: flex;
                    gap: 20px;
                    margin-top: 0px;
                    margin-bottom: 10px;
                  "
                >
                  <div class="try">
                    <mat-checkbox
                      id="testing1"
                      [(ngModel)]="isPointToReferee"
                      class="point-checkbox"
                    >
                      <span
                        class="check-label"
                        style="position: relative; top: 5px"
                        >Credit points to referred person</span
                      >
                    </mat-checkbox>
                  </div>
                </div>

                <div class="loyalty_points_wrap" *ngIf="isPointToReferee">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                    ><mat-label>Points to referred person</mat-label
                    ><input
                      matInput
                      type="number"
                      smDecimalOnly
                      [(ngModel)]="referFriendReferrerPoints"
                  /></mat-form-field>
                </div>
                <div class="loyalty_points_wrap" *ngIf="isPointToReferee">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                    ><mat-label>Valid for (days)</mat-label>
                    <input
                      [(ngModel)]="referFriendReferredPointsValidity"
                      matInput
                      type="number"
                      smNumericOnly
                      placeholder="Enter validity days"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>

          <div class="item_list add_padding">
            <div class="item_list_data">
              <span>On first booking / membership by referred person</span
              ><mat-slide-toggle
                [(ngModel)]="isBookingByRefereeEnabled"
              ></mat-slide-toggle>
            </div>
            <div class="loyalty_payment_box" *ngIf="isBookingByRefereeEnabled">
              <div class="loyalty_points_wrap">
                <mat-form-field appearance="outline" class="mobile_form col-12"
                  ><mat-label>Points on first booking</mat-label
                  ><input
                    matInput
                    type="number"
                    smDecimalOnly
                    [(ngModel)]="refereeBookingPoints"
                /></mat-form-field>
              </div>
              <div class="loyalty_points_wrap">
                <mat-form-field appearance="outline" class="mobile_form col-12"
                  ><mat-label>Valid for (days)</mat-label>
                  <input
                    [(ngModel)]="referralBookingValidity"
                    matInput
                    type="number"
                    smNumericOnly
                    placeholder="Enter validity days"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="item_list add_padding">
            <div class="item_list_data">
              <span>On first payment by referred person</span
              ><mat-slide-toggle
                [(ngModel)]="isPaymentByRefereeEnabled"
              ></mat-slide-toggle>
            </div>
            <div class="loyalty_payment_box" *ngIf="isPaymentByRefereeEnabled">
              <mat-radio-group
                class="payment_radio_group"
                [(ngModel)]="referralPaymentType"
              >
                <div class="radio_row mainpayment">
                  <mat-radio-button value="each_payment"
                    >On any amount</mat-radio-button
                  ><mat-radio-button value="payment_amount"
                    >Based on payment value</mat-radio-button
                  >
                </div>
              </mat-radio-group>
              <div *ngIf="referralPaymentType === 'each_payment'">
                <mat-form-field appearance="outline"
                  ><mat-label>Point on first payment</mat-label
                  ><input
                    matInput
                    type="number"
                    smDecimalOnly
                    [(ngModel)]="referralPaymentFixedPoints"
                /></mat-form-field>
              </div>
              <div
                class="each_pay"
                *ngIf="referralPaymentType === 'payment_amount'"
              >
                <div class="radio_row matrow">
                  <div class="amount_input">
                    <span class="text_label"
                      >For each {{ currencyInfo.currencySymbol }}</span
                    ><mat-form-field appearance="outline"
                      ><input
                        matInput
                        type="number"
                        smDecimalOnly
                        [(ngModel)]="referralPaymentAmountLimit"
                    /></mat-form-field>
                    <span class="text_label opentrat">payment,</span>
                  </div>
                  <div class="amount_input paymenx">
                    <span class="text_label">Reward</span
                    ><mat-form-field appearance="outline"
                      ><input
                        matInput
                        type="number"
                        smDecimalOnly
                        [(ngModel)]="referralPaymentRewardPoints"
                    /></mat-form-field>
                    <div class="xvp">
                      <span class="text_label opentrat">point(s)</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="loyalty_points_wrap"
                *ngIf="isPaymentByRefereeEnabled"
              >
                <mat-form-field appearance="outline" class="mobile_form col-12"
                  ><mat-label>Valid for (days)</mat-label>
                  <input
                    [(ngModel)]="referralPaymentValidity"
                    matInput
                    type="number"
                    smNumericOnly
                    placeholder="Enter validity days"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="cabh_sect">
            <button
              (click)="saveReferralLoyaltyConfiguration()"
              [disabled]="isReferralSaveDisabled()"
              mat-flat-button
              color="accent"
              class="submit-btn"
            >
              Save
            </button>
          </div>
        </div>
      </div>
      <div class="lsk_cardf" *ngIf="selectedValue == 4">
        <div class="serv_heading">
          <div class="adm_set">
            <mat-slide-toggle
              (change)="onToggleChangeForMembership($event)"
              [checked]="toShowCheckForMembership === 1"
            ></mat-slide-toggle>
          </div>
          <h3>Membership loyalty reward status</h3>
          <p class="booking_parax">
            {{
              toShowCheckForMembership == 1
                ? "Membership loyalty is enabled"
                : "Membership loyalty is disabled"
            }}
          </p>
        </div>
        <div class="configuration_description">
          <p>
            Reward points help drive growth while controlling costs. With new
            memberships one can receive rewards too. This gives members a sense
            of recognition and added value for being part of the community,
            encouraging continued engagement and long-term membership.
          </p>
        </div>

        <div *ngIf="toShowCheckForMembership == 1">
          <div class="mainpadding" *ngIf="shop_status != '2'">
            <div class="item_list add_padding mainlist">
              <div class="item_list_data">
                <span>In-premise membership</span>
                <mat-slide-toggle
                  [(ngModel)]="isInPremiseMembershipEnabled"
                ></mat-slide-toggle>
              </div>
              <div
                class="loyalty_payment_box"
                *ngIf="isInPremiseMembershipEnabled"
                style="padding: 10px"
              >
                <div class="loyalty_points_wrap">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                  >
                    <mat-label>Point on membership</mat-label>

                    <input
                      matInput
                      type="number"
                      smDecimalOnly
                      [(ngModel)]="membershipInPremisePoints"
                      placeholder="Enter points"
                    />
                  </mat-form-field>
                </div>
                <div class="loyalty_points_wrap">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                    ><mat-label>Valid for (days)</mat-label>
                    <input
                      matInput
                      type="number"
                      smNumericOnly
                      [(ngModel)]="membershipInPremiseValidity"
                      placeholder="Enter validity days"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="mainpadding" *ngIf="home_status != '2'">
            <div class="item_list add_padding mainlist">
              <div class="item_list_data">
                <span>Home membership</span>
                <mat-slide-toggle
                  [(ngModel)]="isHomeMembershipEnabled"
                ></mat-slide-toggle>
              </div>
              <div class="loyalty_payment_box" *ngIf="isHomeMembershipEnabled">
                <div class="loyalty_points_wrap">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                  >
                    <mat-label>Point on membership</mat-label>

                    <input
                      matInput
                      type="number"
                      smDecimalOnly
                      [(ngModel)]="membershipHomePoints"
                      placeholder="Enter points"
                    />
                  </mat-form-field>
                </div>
                <div class="loyalty_points_wrap">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                    ><mat-label>Valid for (days)</mat-label>
                    <input
                      matInput
                      type="number"
                      smNumericOnly
                      [(ngModel)]="membershipHomeValidity"
                      placeholder="Enter validity days"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="mainpadding" *ngIf="virtual_status != '2'">
            <div class="item_list add_padding mainlist">
              <div class="item_list_data">
                <span>Virtual membership</span>
                <mat-slide-toggle
                  [(ngModel)]="isVirtualMembershipEnabled"
                ></mat-slide-toggle>
              </div>
              <div
                class="loyalty_payment_box"
                *ngIf="isVirtualMembershipEnabled"
              >
                <div class="loyalty_points_wrap">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                  >
                    <mat-label>Point on membership</mat-label>

                    <input
                      matInput
                      type="number"
                      smDecimalOnly
                      [(ngModel)]="membershipVirtualPoints"
                      placeholder="Enter points"
                    />
                  </mat-form-field>
                </div>
                <div class="loyalty_points_wrap">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                    ><mat-label>Valid for (days)</mat-label>
                    <input
                      matInput
                      type="number"
                      smNumericOnly
                      [(ngModel)]="membershipVirtualValidity"
                      placeholder="Enter validity days"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="cabh_sect">
            <button
              (click)="saveMembershipLoyaltyConfiguration()"
              [disabled]="isMembershipSaveDisabled()"
              mat-flat-button
              color="accent"
              class="submit-btn"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
